import { render, staticRenderFns } from "./OpportunitiesActionManager.vue?vue&type=template&id=70fd3b12"
import script from "./OpportunitiesActionManager.vue?vue&type=script&lang=js"
export * from "./OpportunitiesActionManager.vue?vue&type=script&lang=js"
import style0 from "./OpportunitiesActionManager.vue?vue&type=style&index=0&id=70fd3b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports